import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

import { NAV_DRAWER_ITEMS } from '~/features/dashboard';
import { selectContracts } from '~/features/dashboard/store/selectors';
import * as variables from '~/styles/variables.scss';
import { useHeaderColorChanger } from '~/utils/hooks/useHeaderColorChanger';
import css from './styles.module.scss';
import { getContractsThunk } from '~/features/dashboard/store/actions.thunks';
import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';
import { Loader } from '~/common/loader';
import classNames from 'classnames';
import { MoneyGrid } from '~/features/dashboard/components/money-grid';
import { AddMoney } from '~/features/dashboard/components/add-money';
import { MoneyCardEdit } from '../../components/money-grid/money-card/money-card-edit';

import { useAppRoute } from '~/utils/hooks/useAppRoute';
import { withStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import AppBar from "@material-ui/core/AppBar";
import {MoneyFinancialSummary} from "~/features/dashboard/components/money-financial-summary";
interface MyDealsProps {}

const ColorButton = withStyles(theme => ({
    root: {
        color: theme.palette.getContrastText('#000'),
        backgroundColor: '#000',
        '&:hover': {
            backgroundColor: '#000',
        },
        borderRadius: '20px',
        textTransform: 'capitalize',
    },
}))(Button);

export const MyMoney: React.FC<MyDealsProps> = () => {
    const [isLoading, setIsLoading] = useState(true);
    // const [viewStyle, setViewStyle] = useState<'grid' | 'list'>('grid');

    const config = NAV_DRAWER_ITEMS.money;
    const match = useRouteMatch<{ creatorId: string }>();
    const contracts = useSelector(selectContracts);
    const dispatch = useThunkDispatch();
    useHeaderColorChanger(config.background, variables.colorGreenText);

    useEffect(() => {
        if (match.params.creatorId) {
            dispatch(getContractsThunk({ creatorId: Number(match.params.creatorId) })).finally(() => setIsLoading(false));
        }
    }, [dispatch, match.params.creatorId]);

    // const toggleViewStyle = () => {
    //     setViewStyle(prevState => (prevState === 'grid' ? 'list' : 'grid'));
    // };
    const route = useAppRoute();
    const goToNewMoneyPage = useCallback(() => route(`${match.url}/add-money`), [match.url, route]);

    const [value, setValue] = React.useState(0);

    function a11yProps(index: any) {
        return {
            id: `tab-${index}`,
            'aria-controls': `tabpanel-${index}`,
        };
    }

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setValue(newValue);
    };

    return isLoading ? (
        <Loader />
    ) : (
        <article className={css.module}>
            <div className={classNames(css.topBar)}>
                <Route exact path={`${match.path}/table`}>
                    <div className={css.topBarActions}>
                        <AppBar className={css.appTop} position="static">
                            <Tabs value={value} className={css.topBar} onChange={handleChange} aria-label="simple tabs example">
                                <Tab style={{ whiteSpace: 'nowrap', minWidth: '330px' }} label="My Financial Summary" {...a11yProps(0)} />
                                <Tab label="My Money" {...a11yProps(1)} />
                            </Tabs>
                        </AppBar>
                        <ColorButton className="add-song-btn1" variant="contained" color="primary" onClick={goToNewMoneyPage}>
                            Add New Monies
                        </ColorButton>
                    </div>
                </Route>
            </div>
            <Switch>
                <Route path={`${match.path}/table`}>
                    {value === 0 ? <MoneyFinancialSummary contracts={contracts} /> : <MoneyGrid contracts={contracts} />}
                </Route>
                <Route exact path={match.path}>
                    <Redirect to={`${match.url}/table`} />
                </Route>
                <Route path={`${match.path}/add-money`}>
                    <AddMoney />
                </Route>
                <Route path={`${match.path}/:dealId/edit-deal`}>
                    <MoneyCardEdit />
                </Route>
            </Switch>
        </article>
    );
};
